<script setup lang="ts">
import type { CollapseItem } from '../types'
import YscCollapse from './YscCollapse.vue'

interface Props {
  items: CollapseItem[]
  isFaq?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  items: () => [],
  isFaq: true,
})
</script>

<template>
  <div
    class="divide-y"
    :itemscope="props.isFaq"
    :itemtype="props.isFaq ? 'https://schema.org/FAQPage' : undefined"
  >
    <YscCollapse
      v-for="{ question, answer } in props.items"
      :key="`ysc-faq_${question}`"
      :is-faq="props.isFaq"
    >
      <template #title>
        {{ question }}
      </template>

      <template #contentBlock>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="answer" />
      </template>
    </YscCollapse>
  </div>
</template>
